var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchLightBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13209_5950)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    fill: "#6C757E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5911 33.6082L31.2356 29.2508C34.4946 24.8956 33.606 18.723 29.2508 15.464C24.8956 12.205 18.723 13.0936 15.464 17.4488C12.205 21.804 13.0936 27.9766 17.4488 31.2356C20.9473 33.8535 25.7523 33.8535 29.2508 31.2356L33.6082 35.593C34.1557 36.1405 35.0435 36.1405 35.5911 35.593C36.1387 35.0454 36.1387 34.1576 35.5911 33.61L35.5911 33.6082ZM23.3861 30.3946C19.5154 30.3946 16.3777 27.2568 16.3777 23.3861C16.3777 19.5154 19.5154 16.3777 23.3861 16.3777C27.2568 16.3777 30.3946 19.5154 30.3946 23.3861C30.3905 27.255 27.2551 30.3904 23.3861 30.3946Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13209_5950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLightBg);
export default __webpack_public_path__ + "static/media/search-light-bg.9b21fd640f5571c336787bede359228a.svg";
export { ForwardRef as ReactComponent };